import RootState from 'typings/RootState'
import { Event } from '../../types/event'
import { DataList, DataDetail } from './types'

export const selectEvent = (state: RootState): Event =>
  state.adminReportConstructPlan.Event

export const selectReportList = (state: RootState): DataList =>
  state.adminReportConstructPlan.DataList

export const selectReportDetail = (state: RootState): DataDetail =>
  state.adminReportConstructPlan.DataDetail

export const selectFilter = (state: RootState) =>
  state.adminReportConstructPlan.Filter

export const selectInitFilter = (state: RootState) =>
  state.adminReportConstructPlan.ClearFilter

export const selectSorting = (state: RootState) =>
  state.adminReportConstructPlan.sorting
